import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import queryString from 'query-string';

import { Table, TableBody, TableHead, TableCell, TableContainer, TableRow, Tabs, Tab } from '@mui/material';
import Chip from '@mui/material/Chip';

// import { getStationsByQuery } from 'components/axios/stationAxios';
import { getEquipmentsByQuery, getEquipmentsCount } from 'components/axios/equipmentAxios';
import { getDashboardCountGroupByStatus } from 'components/axios/dashboardAxios';

import { useEnumApi } from 'contexts/EnumApiContext';
import MainCard from 'components/MainCard';
import { Link } from 'react-router-dom';
import { equipmentISOStatus, getEquipmentCtgrImageNameByCodeOfDashboardSub, getTemperatureColor } from 'data/data';
import { getLatestTemperatureByEquipmentsByQuery } from 'components/axios/equipmentAlertsAxios';
import PanoViewer from 'components/PanoViewer';

function DashboardMoniteringSub() {
  const { getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s } = useEnumApi();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const timerRef = useRef(null);
  
  let qs = queryString.parse(window.location.search);

  // 설비개수
  const [equipmentIotCount, setEquipmentIotCount] = useState(0);
  // 등록현황
  const [station, setStation] = useState(null);
  // 상태현황
  const [statusDatas, setStatusDatas] = useState(null);
  // 설비목록
  const [equipments, setEquipments] = useState([]);
  // 설비상태목록
  // const [equipmentStatuss, setEquipmentStatuss] = useState([]);
  // 설비온도목록록
  const [equipmentLatestTemperatures, setEquipmentLatestTemperatures] = useState([]);

  useEffect(()=>{
    return () => {
      console.log('other page move')
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    }
  },[]);

  useEffect(()=>{
    if (qs.bid && !isLoading && equipmentCategoryLevel1s != null && equipmentCategoryLevel1s.length > 0) {
      repeatFunc();
    }
  },[qs.bid, isLoading, equipmentCategoryLevel1s]);

  function repeatFunc() {
    try {
      console.log("repeatFunc()");
      // categoryStatusCount();
      Promise.all([
        // getStationsByQuery({id:qs.stationId}).then((data)=>{
        //   if (data && data._embedded) {
        //     setStation(data._embedded.stations[0]);
        //   }
        // }),
        // getEquipmentsCount({"station.id": qs.stationId,iotInstlYn:true}).then((data)=>{
        getEquipmentsCount({iotInstlYn:true}).then((data)=>{
          setEquipmentIotCount(data);
        }),
        // getDashboardCountGroupByStatus({"station.id": qs.stationId}).then((data)=>{
        getDashboardCountGroupByStatus({}).then((data)=>{
          // setStatusDatas(data);
          return data;
        }),
        // getEquipmentsByQuery({"station.id": qs.stationId}).then((data)=>{
        getEquipmentsByQuery({iotInstlYn : true}).then((data)=>{
          if (data && data._embedded && data._embedded.equipments) {
            setEquipments(data._embedded.equipments);
            return data._embedded.equipments;
          } else {
            setEquipments([]);
            return null;
          }
          // return data;
        }),
        // getDashboardCountGroupByFollowActionType({"station.id": qs.stationId}).then((data)=>{
        //   return data;
        // }),
        // getLatestTemperatureByEquipmentsByQuery({"station.id": qs.stationId}).then((data)=>{
        getLatestTemperatureByEquipmentsByQuery({}).then((data)=>{
          setEquipmentLatestTemperatures(data);
        })
      ]).then((result)=>{
        
        if (result && result[1]) {
          setStatusDatas([...result[1]])
        }

        categoryStatusCount();
        setIsLoading(true);
      })
    } catch (error) {
			console.error(error);
		} finally {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      timerRef.current = setTimeout(repeatFunc, 5000);
		}
  }

  // 설비대분류별 상태현황
  const [equipmentCtgrResult, setEquipmentCtgrResult] = useState([]);

  useEffect(() => {
      categoryStatusCount();
  }, [equipmentCategoryLevel1s]);

  function categoryStatusCount() {
    // console.log(isLoading)
    const fetchData = async () => {
      try {
        // console.log(equipmentCategoryLevel1s.length)
        const promises = equipmentCategoryLevel1s.map(async(item) => {
            // const api1Result = await getDashboardCountGroupByStatus({"station.id": qs.stationId, 'category.code' : item.code});
            const api1Result = await getDashboardCountGroupByStatus({'category.code' : item.code});
            return {
              code : item.code
              , data : [...api1Result]
              // , data : [...api1Result, ...api2Result]
              // , statusCount : [...api2Result]
            };
        });
        const responses = await Promise.all(promises);
        // console.log(responses)
        setEquipmentCtgrResult(responses);
      } catch (error) {
        console.error('API 호출 중 오류 발생:', error);
      }
    };

    fetchData();
  }

  const [selectTab, setSelectTab] = useState('ALL');

  const selectTabValue = (event, newValue1) => {
    setSelectTab(newValue1);
  };
  
  if (isLoading ) {
    const nomalCnt = statusDatas?.reduce((acc, cur)=>{
      if (cur.name === 'O1_N') {
          return acc + cur.count;
      }
      return acc
    },0);

    const communiCnt = statusDatas?.reduce((acc, cur)=>{
      // if (cur.name === 'O2_M') {
      if (cur.name === 'O4_C') {
          return acc + cur.count;
      }
      return acc
    },0);
    // if (faultCnt == null) faultCnt = 0;

    const alertCnt = statusDatas?.reduce((acc, cur)=>{
      // if (cur.name === 'O1_WAIT') {
      if (cur.name === 'O3_A') {
          return acc + cur.count;
      }
      return acc
    },0);

    const referCnt = statusDatas?.reduce((acc, cur)=>{
      // if (cur.name === 'O4_NORMAL') {
      if (cur.name === 'O2_I') {
          return acc + cur.count;
      }
      return acc
    },0);

  return (
      <div className="main_container cn_sub_container">
        <div className="sub_subwayline">
          <span>･</span>(주)백운
        </div>

        {/* registration status */}
        <div className='cn_sub_reg'>
          <MainCard  content={false} title="">
            <div div style={{display: "flex", alignItems: "center"}}>
              <div style={{padding:"5px 10px"}}>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                <Chip label={t('message.common.chip.registration.status')} color="default" />
              </div>
            </div>

            <TableContainer className="table_part">
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t('message.common.subtitle.manager.count')}</TableCell>
                    <TableCell>{t('message.common.subtitle.tel.number')}</TableCell>
                    <TableCell>{t('message.common.subtitle.equipment.count')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>{equipmentIotCount}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>                          
          </MainCard>
        </div>  

        {/* status count */}
        <div className='cn_sub_status'>
          <MainCard  content={false} title="">
            <div div style={{display: "flex", alignItems: "center"}}>
              <div style={{padding:"5px 10px"}}>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                <Chip label={t('message.common.chip.situation.status')} color="default" />
              </div>
            </div>
            
            <TableContainer className="table_part">
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell>{t('message.common.total')}</TableCell>
                    <TableCell><Link to={`/equipment`}>{equipmentIotCount}</Link></TableCell>
                    <TableCell>{t('message.common.normal')}</TableCell>
                    <TableCell><Link className='font_blue' to={`/equipment?searchStatus=O1_N`}>{nomalCnt}</Link></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t('message.common.interest')}</TableCell>
                    <TableCell><Link className='font_yellow' to={`/equipment?searchStatus=O2_I`}>{referCnt}</Link></TableCell>
                    <TableCell>{t('message.common.title.alarm')}</TableCell>
                    <TableCell><Link className='font_red' to={`/equipment?searchStatus=O3_A`}>{alertCnt}</Link></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t('message.common.subtitle.communication')}</TableCell>
                    <TableCell><Link className='font_gray' to={`/equipment?searchStatus=O4_C`}>{communiCnt}</Link></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>                          
          </MainCard>
        </div> 

        {/* train station */}
        <div className="sub_motion_train">
          {/* <img src={`${process.env.PUBLIC_URL}/img/backwoon.jpg`} alt='' /> */}
          <PanoViewer fileUrl={`${process.env.PUBLIC_URL}/img/backwoon.jpg`} wSize="1200px" />
          {/* <PanoViewer fileUrl={`${process.env.PUBLIC_URL}/img/bs.png`} /> */}
        </div>

        {/* station category status */}
        <div className='cn_sub_equistatus'>
          <div className='cn_sub_equistatus_tab'>
            {/* <div className="alert_box">
              {equipmentCategoryLevel1s && equipmentCategoryLevel1s.map((lvl1, l)=> {
                const categoryData = equipmentCtgrResult && equipmentCtgrResult.find(ctgr => ctgr.code === lvl1.code);
                // console.log(categoryData);
                // const faultCtrlCnt = categoryData?.data?.reduce((acc, cur)=>{
                //   if (cur.name === 'O2_M') {
                //     return acc + cur.count;
                //   }
                //   return acc
                // },0);
            
                const alertCtrlCnt = categoryData?.data?.reduce((acc, cur)=>{
                  if (cur.name === 'O3_A') {
                      return acc + cur.count;
                  }
                  return acc
                },0);
            
                const referCtrlCnt = categoryData?.data?.reduce((acc, cur)=>{
                  if (cur.name === 'O2_I') {
                      return acc + cur.count;
                  }
                  return acc
                },0);

                let className = "";
                // if (faultCtrlCnt > 0 || alertCtrlCnt > 0 || referCtrlCnt > 0) {
                if (alertCtrlCnt > 0 || referCtrlCnt > 0) {
                  if (lvl1.code === 'PUMP') className = "alert_pump";
                  if (lvl1.code === 'EV') className = "alert_elevator";
                  if (lvl1.code === 'ES') className = "alert_escalator";
                  if (lvl1.code === 'AHU') className = "alert_airconditioner";
                  // console.log(lvl1.code, alertCtrlCnt, faultCtrlCnt, referCtrlCnt)
                  if (alertCtrlCnt > 0) className += " red_c";
                  // else if (faultCtrlCnt > 0) className += " orange_c";
                  else if (referCtrlCnt > 0) className += " yellow_c";
                }
                if (className) {
                  return (
                  <Link onClick={()=>{(selectTab===lvl1.code)?setSelectTab('ALL'):setSelectTab(lvl1.code)}}><div className={className}><span>!</span></div></Link>
                  )
                }
              })}
            </div> */}

            {/* <Tabs value={selectTab} onChange={selectTabValue} centered sx={{ ".Mui-selected":{fontWeight:"bold",bgcolor:"#eeeeee"} }}>
              {equipmentCategoryLevel1s && equipmentCategoryLevel1s.map((lvl1, l)=> {
                return (
              <Tab key={l} value={lvl1.code} icon={<img src={`${process.env.PUBLIC_URL}/img/small_motion/${getEquipmentCtgrImageNameByCodeOfDashboardSub(lvl1.code)}`} alt={`Tab ${l}`} />} 
                onClick={()=>{(selectTab===lvl1.code)?setSelectTab('ALL'):setSelectTab(lvl1.code)}}/>
                )
              })}
            </Tabs> */}
            {/* <div>
              <a href="#"><div class="alert_sub red_c"><span>!</span></div></a>
              <img src={`${process.env.PUBLIC_URL}/img/small_motion/pump_start.gif`} alt='' />
              </div>
            <div>
              <a href="#"><div class="alert_sub orange_c"><span>!</span></div></a>
              <img src={`${process.env.PUBLIC_URL}/img/small_motion/fan_start.gif`} alt='' />
              </div>
            <div>
              <a href="#"><div class="alert_sub yellow_c"><span>!</span></div></a>
              <img src={`${process.env.PUBLIC_URL}/img/small_motion/elevator.gif`} alt='' />
            </div>
            <div>
              <a href="#"><div class="alert_sub yellow_c"><span>!</span></div></a>
              <img src={`${process.env.PUBLIC_URL}/img/small_motion/escalator.gif`} alt='' />
            </div> */}
            {equipmentCategoryLevel1s && equipmentCategoryLevel1s.map((lvl1, l)=> {
              const categoryData = equipmentCtgrResult && equipmentCtgrResult.find(ctgr => ctgr.code === lvl1.code);
              const alertCtrlCnt = categoryData?.data?.reduce((acc, cur)=>{
                if (cur.name === 'O3_A') {
                    return acc + cur.count;
                }
                return acc
              },0);
          
              const referCtrlCnt = categoryData?.data?.reduce((acc, cur)=>{
                if (cur.name === 'O2_I') {
                    return acc + cur.count;
                }
                return acc
              },0);

              let className = "";
              // if (faultCtrlCnt > 0 || alertCtrlCnt > 0 || referCtrlCnt > 0) {
              if (alertCtrlCnt > 0 || referCtrlCnt > 0) {
                // if (lvl1.code === 'PUMP') className = "alert_pump";
                // if (lvl1.code === 'EV') className = "alert_elevator";
                // if (lvl1.code === 'ES') className = "alert_escalator";
                // if (lvl1.code === 'AHU') className = "alert_airconditioner";
                // console.log(lvl1.code, alertCtrlCnt, faultCtrlCnt, referCtrlCnt)
                className = "alert_sub";
                if (alertCtrlCnt > 0) className += " red_c";
                // else if (faultCtrlCnt > 0) className += " orange_c";
                else if (referCtrlCnt > 0) className += " yellow_c";
              }

              let selectClassName = '';
              if (selectTab === lvl1.code) {
                selectClassName = 'select_active';
              }
              return (
                <div key={l} className={selectClassName} onClick={()=>{(selectTab===lvl1.code)?setSelectTab('ALL'):setSelectTab(lvl1.code)}}>
                  {className && <Link to={`/dashboard/sub?bid=${qs.bid}`} onClick={()=>{(selectTab===lvl1.code)?setSelectTab('ALL'):setSelectTab(lvl1.code)}}><div className={className}><span>!</span></div></Link>}
                  <img src={`${process.env.PUBLIC_URL}/img/small_motion/${getEquipmentCtgrImageNameByCodeOfDashboardSub(lvl1.code)}`} alt={`Tab ${l}`} 
                    onClick={()=>{(selectTab===lvl1.code)?setSelectTab('ALL'):setSelectTab(lvl1.code)}} />
                </div>
              )
            })}
          </div>
        </div>

        {/* category equipment list */}
        <div className='equip_table' style={{position: "relative", zIndex: "99", top: "317px", paddingBottom: "50px"}}>
          <MainCard  content={false} title="">
          {equipmentCategoryLevel1s && equipmentCategoryLevel1s.map((lvl1, l)=> {
            const equipmentsByLvl1 = (equipments != null ? equipments.filter(equip => equip.equipmentCtgr.parent.parent.code === lvl1.code) : []);
            return (
              <div key={l}>
              {(selectTab === 'ALL' || selectTab === lvl1.code) && 
            <div>
              <Chip label={`${lvl1.name} (${equipmentsByLvl1.length})`} className='sub_status' style={{margin:"10px"}} />
              <div className="small_motion_box">
                {equipmentsByLvl1 && equipmentsByLvl1.map((equip, e)=>{
                  // console.log(equipmentStatuss)
                  // const statusByEquip = equipmentStatuss && equipmentStatuss.find(equ => equ.id === equip.id);
                  // console.log(statusByEquip);
                  const temperatureByEquip = equipmentLatestTemperatures && equipmentLatestTemperatures.find(equ => equ.id === equip.id);
                  // console.log(temperatureByEquip);
                  let imgName = 'noimage.gif';
                  let imgClassName = 'bgwhite';
                  if (lvl1.code === 'EV') {
                    imgClassName = 'elevator_motion';
                    if (equip.latestLiftOp != null) {
                      imgName = getEquipmentCtgrImageNameByCodeOfDashboardSub(lvl1.code, equip.latestLiftOp.opStatus, equip.latestLiftOp.doorStatus);
                    } else {
                      imgName = getEquipmentCtgrImageNameByCodeOfDashboardSub(lvl1.code);
                    }
                  } else if (lvl1.code === 'ES') {
                    imgClassName = 'elevator_motion';
                    if (equip.latestLiftOp != null) {
                      imgName = getEquipmentCtgrImageNameByCodeOfDashboardSub(lvl1.code, equip.latestLiftOp.opStatus);
                    } else {
                      imgName = getEquipmentCtgrImageNameByCodeOfDashboardSub(lvl1.code);
                    }
                  } else {
                    imgName = getEquipmentCtgrImageNameByCodeOfDashboardSub(lvl1.code, equip.latestLiftOp?.opStatus);
                  }

                  const isoGrade = equipmentISOStatus.find(iso=>iso.code === equip.lowestDiagnosisRank);

                  const alertEquipCnt = (equip.status === 'O3_A') ? 1 : 0;
                  const referEquipCnt = (equip.status === 'O2_I') ? 1 : 0;

                  let equipmentOpStatusClassName = '';
                  if (equip.opStatus === 'S') {
                    equipmentOpStatusClassName = 'font_red';
                  }

                  return (
                <div key={e} className="small_motion_group">
                  <p className="equipment_tit">* {equip.name} ({equip.equipmentNo})</p>
                  <div className="small_motion">
                    <div>
                      <div className={imgClassName}>
                        <Link to={`/equipment/${equip.id}`}>
                        <div className="alert_box">
                          {alertEquipCnt > 0 ? <div className="red_c"><span>!</span></div> :
                          (
                          // (equip.status === 'O2_M') ? <div className="orange_c"><span>!</span></div> :
                          (referEquipCnt > 0 ? <div className="yellow_c"><span>!</span></div> : '')
                          )
                          }
                        </div>
                        {lvl1.code === 'EV' && <p className='floor'><span className='font_blue'>{equip.latestLiftOp?.opMode || ''}</span><span>{equip.latestLiftOp?.currentFloor || '-'}</span><span className={`${equip.latestLiftOp.opStatus === 'DOWN' ? 'downarrow':''} font_green`}>{equip.latestLiftOp.opStatus === 'UP' ?'▲':equip.latestLiftOp.opStatus === 'DOWN' ? '▼':''}</span></p>}
                        {lvl1.code === 'ES' && <p className='floor'><span className='font_blue'>{equip.latestLiftOp?.opMode || ''}</span><span>-</span><span className={`${equip.latestLiftOp.opStatus === 'DOWN' ? 'downarrow':''} font_green`}>{equip.latestLiftOp.opStatus === 'UP' ?'▲':equip.latestLiftOp.opStatus === 'DOWN' ? '▼':''}</span></p>}
                        <img src={`${process.env.PUBLIC_URL}/img/small_motion/${imgName}`} alt='' />
                        {/* {(lvl1.code === 'EV' || lvl1.code === 'ES') && <p className={`error${equip?.latestLiftOp?.liftControlPanelCode?.usrDfnCd?.toLowerCase() === 'none' ? ' font_green': ''}`}>Error : {equip?.latestLiftOp?.liftControlPanelCode?.usrDfnCd}</p>} */}
                        {(lvl1.code === 'EV' || lvl1.code === 'ES') && 
                          <p className={`error${equip?.latestLiftOp?.liftControlPanelCode?.alertYn === 'N' ? ' font_green': ''}`}>
                            {equip?.latestLiftOp?.liftControlPanelCode?.alertYn === 'N' ? t('message.common.normal') : equip?.latestLiftOp?.liftControlPanelCode?.usrDfnCd}
                          </p>
                        }
                        </Link>
                      </div>

                      <TableContainer className="table_part">
                        <Table aria-label="simple table">
                          <TableBody>
                            {/* <TableRow>
                              <TableCell>{t('message.common.subtitle.type')}</TableCell>
                              <TableCell>{equip.equipmentCtgr.parent.parent.name}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>ISO</TableCell>
                              <TableCell className={isoGrade.color}>{isoGrade.title}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>{t('message.common.subtitle.status')}</TableCell>
                              <TableCell>{getEnumValueByEnumNameAndCode("EquipmentOpStatus",equip.opStatus)[0]?.title}</TableCell>
                            </TableRow> */}
                            <TableRow>
                              <TableCell>{t('message.common.subtitle.equipment.level3')}</TableCell>
                              <TableCell>{equip.equipmentCtgr.name}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>ISO</TableCell>
                              <TableCell className={isoGrade?.color || ''}>{isoGrade?.title || '-'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>{t('message.common.subtitle.equipment.temperature')}</TableCell>
                              <TableCell className={temperatureByEquip?.lowest && getTemperatureColor(temperatureByEquip?.lowest.toFixed(0)) || ''}>{temperatureByEquip?.lowest?.toFixed(0) || '-'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>{t('message.common.subtitle.defect')}</TableCell>
                              <TableCell>{getEnumValueByEnumNameAndCode('EquipmentFaultStatus',equip.status)[0]?.title}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>{t('message.common.subtitle.status')}</TableCell>
                              <TableCell className={equipmentOpStatusClassName}>{getEnumValueByEnumNameAndCode("EquipmentOpStatus",equip.opStatus)[0]?.title}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>      
                    </div>
                  </div>
                </div>
                  )
                })}
              </div>
            </div>
            }
            </div>
            )
          })}
          </MainCard>
        </div>

      </div> 
    )
  }
}

export default DashboardMoniteringSub;